import { Box, Text } from "flicket-ui";
import { useRouter } from "next/router";
import { useEffect } from "react";
import { AnimateReveal } from "~components/AnimateReveal/AnimateReveal";
import { useWillShowPreviewCompetition } from "~features/events/hooks/usePreviewCompetition";
import { EventPermissions } from "~graphql/sdk";
import { useAccount } from "~hooks";
import { useGetEventWithAccessControl } from "~hooks/useGetEventWithAccessControl";

//this value being static is an issue when the text inside the lable is too long for one
const BANNER_HEIGHT = 36;
export default function HeaderAlertBanner() {
  const {
    isBannerVisible,
    showAdminPreviewBanner,
    showBackOfficeOrderBanner,
  } = useShowHeaderBanner();

  if (!isBannerVisible) {
    return null;
  }

  const label = (() => {
    if (showAdminPreviewBanner) {
      return "Event preview";
    }

    if (showBackOfficeOrderBanner) {
      return "Back office order";
    }

    return "";
  })();

  return (
    <Text
      color="N100"
      variant="header.XS"
      textAlign="center"
      backgroundColor="N800"
      py={"3/4"}
      css={`
        min-height: ${BANNER_HEIGHT}px;
        height: auto;
        white-space: normal;
        overflow: visible;
        word-wrap: break-word;
        word-break: break-word;
        width: 100%;
      `}
    >
      {label}
    </Text>
  );
}

export function useShowHeaderBanner() {
  const { pathname } = useRouter();
  const { permissions, isLoading } = useGetEventWithAccessControl();
  const { isAdmin, authState } = useAccount();
  const showPreviewCompetition = useWillShowPreviewCompetition();

  const showAdminPreviewBanner = (() => {
    if (isLoading) return false;
    if (showPreviewCompetition) return true;
    if (
      permissions.includes(EventPermissions.ViewInfoAdmin) &&
      pathname.includes("/events")
    )
      return true;
    if (
      permissions.includes(EventPermissions.ViewTicketsAdmin) &&
      pathname.includes("/reservation")
    )
      return true;
  })();

  const showBackOfficeOrderBanner =
    authState === "authenticated" &&
    isAdmin &&
    (pathname.includes("/reservation") ||
      pathname.includes("/orders") ||
      pathname.includes("/checkout/"));

  const isBannerVisible = showAdminPreviewBanner || showBackOfficeOrderBanner;
  const activeBannerHeight = isBannerVisible ? BANNER_HEIGHT : 0;

  useEffect(() => {
    document.body.style.transition = "padding-top 0.3s ease";
    document.body.style.paddingTop = `${activeBannerHeight}px`;
  }, [activeBannerHeight]);

  return {
    showAdminPreviewBanner,
    showBackOfficeOrderBanner,
    isBannerVisible,
    bannerHeight: BANNER_HEIGHT,
    activeBannerHeight,
  };
}

export function FixedHeaderAlertBanner() {
  return (
    <Box
      css={`
        z-index: 1400;
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        align-items: center;
      `}
      flexWrap="wrap"
    >
      <HeaderAlertBanner />
    </Box>
  );
}
